/**
 * Root-path segments that are named routes, never deal slugs. The public
 * deal-landing screen (`app/[slug].tsx`) renders NotFound for these so
 * Expo Router's own routes resolve; the share-preview middleware
 * (`lib/linkPreview.ts`) leaves them alone so a crawler hitting /login
 * still gets the real page.
 *
 * Add every new top-level route here too.
 */
export const RESERVED_SLUGS: ReadonlySet<string> = new Set([
  'login',
  'verify',
  'signup',
  'name',
  'cashout',
  'deals',
  'earnings',
  'leaderboard',
  // Create tab (app/(tabs)/create.tsx): athletes' MarketPryce Social deals.
  'create',
  'profile',
  'referrals',
  'index',
  '+not-found',
  'not-found',
  'notifications-priming',
  // Alias route (app/refer.tsx) — never a deal slug.
  'refer',
  // Season of Gifting campaign route group (app/season-of-gifting/).
  'season-of-gifting',
  // Branded alias (app/campus-drop.tsx) → redirects to the canonical path.
  'campus-drop',
  // Apple's legacy root-level site-association probe. Nothing is served
  // there (the real file is under /.well-known/), but a crawler asking for
  // it must get a 404, not a "deal not found" card.
  'apple-app-site-association',
]);

/** Deal slugs are kebab-case; anything else is a file, a format or a typo. */
export const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
